import { addressService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    addresses: [
        {
            id: 0,
            value: null
        }
    ]
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, addresses) {
        state.status    = 'success'
        state.addresses = addresses
    },
    fail(state) {
        state.status    = 'fail'
        state.addresses = []
    },
}

const getters = {
    status: state => state.status,
    addresses: state => state.addresses
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return addressService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchByShopId({commit}, params) {
        commit('loading')
        return addressService.fetchByShopId(params).then(response => {
            commit('success', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}